export function toEuro(amount) {
  return new Intl.NumberFormat("fr-FR", { style: 'currency', currency: 'EUR', maximumFractionDigits: 2 }).format(amount)
}